module.exports = __webpack_public_path__ + "img/IRE.6de4b366.svg";